import script from "./BreadcrumbsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadcrumbsComponent.vue?vue&type=script&setup=true&lang=js"

import "./BreadcrumbsComponent.vue?vue&type=style&index=0&id=261c7110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-261c7110"]])

export default __exports__